import { IArticle } from '@alberta/konexi-shared';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ArticlePipesModule } from '@common/pipes/article/article-pipes.module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AlbertaIconModule } from '../alberta-icon/alberta-icon.module';
import { AlbertaCommonComponentsModule } from '../common/common-components.module';
import { IconButtonModule } from '../inputs/icon-button/icon-button.module';
import { AlbertaInputsModule } from '../inputs/inputs-components.module';
@Component({
  selector: 'itl-article-list-item',
  templateUrl: './article-list-item.component.html',
  styleUrls: ['./article-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AlbertaCommonComponentsModule,
    IonicModule,
    TranslateModule,
    AlbertaIconModule,
    CommonModule,
    AlbertaInputsModule,
    IconButtonModule,
    ArticlePipesModule,
  ],
})
export class ArticleListItemComponent implements OnInit, AfterViewInit {
  @Input() actions: TemplateRef<any>;
  @Input() labels: TemplateRef<any>;
  @Input() stars: TemplateRef<any>;
  @Input() cards: TemplateRef<any>;
  @Input() additionalCards: TemplateRef<any>;
  @Input() infoBoxes: TemplateRef<any>;
  @Input() dosage: TemplateRef<any>;

  @Input() position: string;
  @Input() article: IArticle;
  @Input() disabled: boolean;
  @Input() icon = 'alberta-article';

  @Input() showChevron = true;
  @Input() showCheckbox = false;

  @Input() checked: boolean;
  @Output() checkedChange = new EventEmitter<boolean>();

  isExpanded = false;
  isSmallScreen = false;

  hasLabels: boolean;
  hasActions: boolean;
  hasAdditionalCards: boolean;
  hasInfoBoxes: boolean;
  hasDosage: boolean;

  constructor(
    private _breakpointObserver: BreakpointObserver,
    private _changeDetectorRef: ChangeDetectorRef,
    private _viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this._breakpointObserver.observe('(max-width: 700px)').subscribe(result => {
      this.isSmallScreen = result.matches;
      this._changeDetectorRef.markForCheck();
    });
  }
  onCheckboxChange(event: CustomEvent): void {
    this.checked = event.detail.checked;
    this.checkedChange.emit(this.checked);
  }

  ngAfterViewInit(): void {
    if (this.labels) {
      const labelsView = this._viewContainerRef.createEmbeddedView(this.labels);
      this.hasLabels = labelsView.rootNodes.length > 0;
      labelsView.destroy();
    }
    if (this.actions) {
      const actionsView = this._viewContainerRef.createEmbeddedView(this.actions);
      this.hasActions = actionsView.rootNodes.length > 0;
      actionsView.destroy();
    }

    if (this.additionalCards) {
      const additionalCardsView = this._viewContainerRef.createEmbeddedView(this.additionalCards);
      this.showChevron =
        additionalCardsView.rootNodes.length > 0 ||
        !!this.article.manufacturer ||
        !!this.article?.inventoryType ||
        !!this.article?.medicalAidPositionNumber ||
        !!this.article?.ean ||
        !!this.article?.size;
      additionalCardsView.destroy();
    }

    if (this.infoBoxes) {
      const infoBoxesView = this._viewContainerRef.createEmbeddedView(this.infoBoxes);
      this.hasInfoBoxes = infoBoxesView.rootNodes.length > 0;
      infoBoxesView.destroy();
    }

    if (this.dosage) {
      const dosageView = this._viewContainerRef.createEmbeddedView(this.dosage);
      this.hasDosage = dosageView.rootNodes.length > 0;
      dosageView.destroy();
    }

    this._changeDetectorRef.detectChanges();
  }
}
